import moment from "moment"
const newModel = () => {
    return {
        id: null,
        reportName: null,
        imageUrl: null,
        isChangedImage: null,
        localImage: null,
        localImageUrl: null,
        workspaceId: null,
        isWebUrl: null,
        webUrl: null,
        pbiReportInfoStr: null,
        pbiReportId: null,
        pbiReportName: null,
        pbiReportType: null,
        pbiWebUrl: null,
        pbiEmbedUrl: null,
        pbiIsFromPbix: null,
        pbiIsOwnedByMe: null,
        pbiDatasetId: null,
        pbiDatasetWorkspaceId: null,
        status: null,
        isDeleted: null,
        createdAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
        createdBy: null,
        updatedAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
        updatedBy: null
    }
}

export const reportModel = {
    newModel
}
